import axios from 'axios'

const apiKey = "P9P2XNCES6WH5852BAQSXE64BT868EAFCEHACSKEUTNDMMFE6HJ4JTT8DQSBEDHF";
const host = "https://acs.accelery.de"

export default () => {
    return axios.create({
      baseURL: host  + `/api`,
      headers: {
        "X-Api-Key": apiKey
      },
      withCredentials: true,
    })
  }
